export const DEFAULT_SHORT_MAX_DURATION_SECONDS = 15;
export const SHORT_DURATION_FIREBASE_BUFFER_SECONDS = 1;
export const SHORT_MEDIA_CACHE_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
export const SHORT_IN_MEMORY_MAX_VIDEOS = 4;
export const SHORT_MEDIA_CACHE_MAX_BYTES = 200 * 1024 * 1024; // 200 MB
